import React, { useState } from "react";
import AdminDashboardLayout from "../../../layout/AdminDashboardLayout";
import { StyledContainer } from "../../../globalStyle/GlobalStyle";
import { ParametersWrapper } from "../Parameters.styled";
import { FormContainer, StyledForm } from "../../../components/Form/FormComponents.styled";
import { InputField, SelectField } from "../../../components/Form/FormComponents";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import { BiArrowBack } from "react-icons/bi";
import { Link } from "react-router-dom";
import { createParameter } from "../utils";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const AddParameter = () => {
	const [formData, setFormData] = useState({});
	const [loading, setLoading] = useState(false);
	const variablesOptions = useSelector((state) => state.parameters.variables);

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setLoading(true);
		console.log(formData);

		const data = createParameter(formData);
		if (data && !data.error) {
			console.log(data);
			setLoading(false);
			toast.success("Parameter added successfully!");
			setFormData({});
		} else {
			setLoading(false);
			toast.error("Error adding parameter!");
		}
	};

	return (
		<AdminDashboardLayout>
			<StyledContainer>
				<ParametersWrapper>
					<Link
						to='/parameters'
						style={{ color: "#408D94", width: "fit-content", marginBottom: "2.25rem" }}
						className='flex gap-2 border '>
						<BiArrowBack size={24} />
						<p>Go back</p>
					</Link>

					<FormContainer>
						<StyledForm onSubmit={handleSubmit}>
							<div className='parametersList w-full'>
								<div className='grid grid-cols-4 gap-3'>
									<div className='heading'>Parameters</div>
									<div className='heading'>Value</div>
									<div className='heading'>Period</div>
									<div className='heading'>Terms</div>
								</div>

								<div className='grid grid-cols-4 gap-3'>
									<div className='listItem'>
										<InputField
											name={"parameter"}
											handleChange={(e) => handleInputChange(e, formData?.id)}
											isEditable={true}
											placeholder='Enter parameter name'
											value={formData?.parameter}
										/>
									</div>

									<div className='listItem'>
										<InputField
											name={"value"}
											handleChange={(e) => handleInputChange(e, formData?.id)}
											isEditable={true}
											placeholder='Enter value'
											value={formData?.value}
										/>
									</div>

									<div className='listItem'>
										<SelectField
											name={"period"}
											handleChange={(e) => handleInputChange(e, formData?.id)}
											isEditable={true}
											value={formData?.period}
											options={variablesOptions.period}
										/>
									</div>

									<div className='listItem'>
										<SelectField
											name={"term"}
											handleChange={(e) => handleInputChange(e, formData?.id)}
											isEditable={true}
											value={formData?.term}
											options={variablesOptions.terms}
										/>
									</div>
								</div>

								<div className='actions flex mt-5' style={{}}>
									<Button variant='contained' type='submit'>
										Save
									</Button>
								</div>
							</div>
						</StyledForm>
					</FormContainer>
				</ParametersWrapper>
			</StyledContainer>

			{loading && (
				<Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</AdminDashboardLayout>
	);
};

export default AddParameter;
